import React from 'react';
import { withStyles } from '@material-ui/core';
import moment from 'moment';

const PacienteInfo = ({ classes, paciente }) => {
  const { nome, altura, peso, dadosConvenio, dataNascimento } = paciente || {};
  
  const idade = dataNascimento ? moment().diff(moment(dataNascimento), 'years') : null;
  return (
    <div className={classes.container}>
      <div className={classes.infoItem}style={{width:'100%',fontSize:'15px'}}>
        <span className={classes.label}>{nome || 'N/A'}</span>
      </div>
      <div className={classes.infoItem}>
        <span className={classes.label}>Altura:</span>
        <span className={classes.value}>{altura ? `${altura} cm` : 'N/A'}</span>
      </div>
      <div className={classes.infoItem}>
        <span className={classes.label}>Peso:</span>
        <span className={classes.value}>{peso ? `${peso} kg` : 'N/A'}</span>
      </div>
      <div className={classes.infoItem}>
        <span className={classes.label}>Convênio:</span>
        <span className={classes.value}>{dadosConvenio?.convenio?.descricao || 'N/A'}</span>
      </div>
      <div className={classes.infoItem}>
        <span className={classes.label}>Idade:</span>
        <span className={classes.value}>{idade !== null ? `${idade} anos` : 'N/A'}</span>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px 30px',
    padding: '10px 20px 0px 20px',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'row',
    gap:'5px'
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#666',
    marginBottom: '4px'
  },
  value: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#333'
  }
};

export default withStyles(styles)(PacienteInfo);